/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'

type GLTFResult = GLTF & {
  nodes: {
    map_8osm_buildings: THREE.Mesh
    map_8osm_buildings_1: THREE.Mesh
    map_8osm_buildings_2: THREE.Mesh
    map_8osm_buildings_3: THREE.Mesh
    map_8osm_buildings_4: THREE.Mesh
    map_8osm_buildings_5: THREE.Mesh
    element011: THREE.Mesh
    element011_1: THREE.Mesh
    Mast_1: THREE.Mesh
    Cube006_1: THREE.Mesh
    Mast_1001: THREE.Mesh
    Cube001: THREE.Mesh
    Mast_1002: THREE.Mesh
    Cube002: THREE.Mesh
    Mast_1003: THREE.Mesh
    Blaaktoren_1: THREE.Mesh
    Blaaktoren_2: THREE.Mesh
    element002_1: THREE.Mesh
    element002_2: THREE.Mesh
    Centrale_Bibliotheek_1: THREE.Mesh
    Centrale_Bibliotheek_2: THREE.Mesh
    Centrale_Bibliotheek001_1: THREE.Mesh
    Centrale_Bibliotheek001_2: THREE.Mesh
    Centrale_Bibliotheek002_1: THREE.Mesh
    Centrale_Bibliotheek002_2: THREE.Mesh
    Cylinder: THREE.Mesh
    Cylinder001: THREE.Mesh
    Cylinder002: THREE.Mesh
    Cylinder003: THREE.Mesh
    Cylinder004: THREE.Mesh
    Cylinder005: THREE.Mesh
    Cylinder006: THREE.Mesh
    Cylinder007: THREE.Mesh
    Cylinder008: THREE.Mesh
    Cylinder009: THREE.Mesh
    Cylinder010: THREE.Mesh
    Cylinder011: THREE.Mesh
    Cylinder012: THREE.Mesh
    Cylinder013: THREE.Mesh
    Cylinder014: THREE.Mesh
    Cylinder015: THREE.Mesh
    Cylinder016: THREE.Mesh
    Cylinder017: THREE.Mesh
    Grass001: THREE.Mesh
    Rotterdam_Blaak_1: THREE.Mesh
    Rotterdam_Blaak_2: THREE.Mesh
    Cylinder018: THREE.Mesh
    Cylinder019: THREE.Mesh
    Cylinder020: THREE.Mesh
    Cylinder021: THREE.Mesh
    Cylinder022: THREE.Mesh
    Cylinder023: THREE.Mesh
    Cylinder024: THREE.Mesh
    Cylinder025: THREE.Mesh
    Plane: THREE.Mesh
    Plane001: THREE.Mesh
    Grass002: THREE.Mesh
    Markthal: THREE.Mesh
    Cube008: THREE.Mesh
    Cube010: THREE.Mesh
    Erasmusbrug: THREE.Mesh
    Cube007_2: THREE.Mesh
    Cylinder050: THREE.Mesh
    Cylinder051: THREE.Mesh
    Plane002_1: THREE.Mesh
    Cube007: THREE.Mesh
    Cube007_1: THREE.Mesh
    Cube: THREE.Mesh
    Cube004: THREE.Mesh
    Tree_1001_1: THREE.Mesh
    Tree_1001_2: THREE.Mesh
    Tree_1002_1: THREE.Mesh
    Tree_1002_2: THREE.Mesh
    Tree_1003_1: THREE.Mesh
    Tree_1003_2: THREE.Mesh
    Tree_2_1: THREE.Mesh
    Tree_2_2: THREE.Mesh
    Tree_2001_1: THREE.Mesh
    Tree_2001_2: THREE.Mesh
    Tree_2002_1: THREE.Mesh
    Tree_2002_2: THREE.Mesh
    Tree_2003_1: THREE.Mesh
    Tree_2003_2: THREE.Mesh
    Tree_2004_1: THREE.Mesh
    Tree_2004_2: THREE.Mesh
    Tree_2005_1: THREE.Mesh
    Tree_2005_2: THREE.Mesh
    Tree_1004_1: THREE.Mesh
    Tree_1004_2: THREE.Mesh
    Tree_2006_1: THREE.Mesh
    Tree_2006_2: THREE.Mesh
    Tree_1005_1: THREE.Mesh
    Tree_1005_2: THREE.Mesh
    Grass003: THREE.Mesh
    Tree_1006_1: THREE.Mesh
    Tree_1006_2: THREE.Mesh
    Tree_2007_1: THREE.Mesh
    Tree_2007_2: THREE.Mesh
    Tree_1007_1: THREE.Mesh
    Tree_1007_2: THREE.Mesh
    Tree_2008_1: THREE.Mesh
    Tree_2008_2: THREE.Mesh
    Tree_2009_1: THREE.Mesh
    Tree_2009_2: THREE.Mesh
    Tree_1008_1: THREE.Mesh
    Tree_1008_2: THREE.Mesh
    Tree_1009_1: THREE.Mesh
    Tree_1009_2: THREE.Mesh
    Tree_1010_1: THREE.Mesh
    Tree_1010_2: THREE.Mesh
    Tree_2010_1: THREE.Mesh
    Tree_2010_2: THREE.Mesh
    Tree_2011_1: THREE.Mesh
    Tree_2011_2: THREE.Mesh
    Tree_2012_1: THREE.Mesh
    Tree_2012_2: THREE.Mesh
    Cube003: THREE.Mesh
    Plane006: THREE.Mesh
    Cube005: THREE.Mesh
    NurbsCurve003: THREE.Mesh
    NurbsCurve002: THREE.Mesh
    NurbsCurve001: THREE.Mesh
    NurbsCurve: THREE.Mesh
    Circle007: THREE.Mesh
    Circle006: THREE.Mesh
    Circle005: THREE.Mesh
    Circle004: THREE.Mesh
    Cube004_Cube003: THREE.Mesh
    Cube003_Cube002: THREE.Mesh
    Cylinder041_Cylinder042: THREE.Mesh
    Circle003: THREE.Mesh
    Cylinder038_Cylinder039: THREE.Mesh
    Cylinder037_Cylinder038: THREE.Mesh
    Cylinder036_Cylinder037: THREE.Mesh
    Cylinder035_Cylinder036: THREE.Mesh
    Cylinder033_Cylinder034: THREE.Mesh
    Cylinder032_Cylinder033: THREE.Mesh
    Cylinder029_Cylinder030: THREE.Mesh
    Cylinder028_Cylinder029: THREE.Mesh
    Cylinder027_Cylinder028: THREE.Mesh
    Cylinder025_Cylinder026: THREE.Mesh
    Cylinder022_Cylinder023: THREE.Mesh
    Cylinder021_Cylinder022: THREE.Mesh
    Circle002: THREE.Mesh
    Circle001: THREE.Mesh
    Cylinder020_Cylinder021: THREE.Mesh
    Cylinder017_Cylinder018: THREE.Mesh
    Cylinder016_Cylinder017: THREE.Mesh
    Cylinder014_Cylinder015: THREE.Mesh
    Cylinder013_Cylinder014: THREE.Mesh
    Cylinder012_Cylinder013: THREE.Mesh
    Cylinder011_Cylinder012: THREE.Mesh
    Cylinder009_Cylinder010: THREE.Mesh
    Cylinder006_Cylinder007: THREE.Mesh
    Cylinder004_Cylinder005: THREE.Mesh
    Cylinder002_Cylinder003: THREE.Mesh
    Circle: THREE.Mesh
    Cylinder056: THREE.Mesh
    Cylinder057: THREE.Mesh
    Cube001_Cube000: THREE.Mesh
    Cube_Cube001: THREE.Mesh
  }
  materials: {
    b0e0e6: THREE.MeshStandardMaterial
    ['000000']: THREE.MeshStandardMaterial
    ffffff: THREE.MeshStandardMaterial
    c0c0c0: THREE.MeshStandardMaterial
    f0f8ff: THREE.MeshStandardMaterial
    dcdcdc: THREE.MeshStandardMaterial
    roof: THREE.MeshStandardMaterial
    wall: THREE.MeshStandardMaterial
    ['wall.001']: THREE.MeshStandardMaterial
    grey: THREE.MeshStandardMaterial
    ['roof.001']: THREE.MeshStandardMaterial
    ['wall.005']: THREE.MeshStandardMaterial
    ['roof.005']: THREE.MeshStandardMaterial
    ['wall.007']: THREE.MeshStandardMaterial
    ['roof.007']: THREE.MeshStandardMaterial
    ['wall.002']: THREE.MeshStandardMaterial
    ['roof.002']: THREE.MeshStandardMaterial
    ['Library buis']: THREE.MeshStandardMaterial
    ['Material.002']: THREE.MeshStandardMaterial
    ['wall.006']: THREE.MeshStandardMaterial
    ['roof.006']: THREE.MeshStandardMaterial
    Material: THREE.MeshStandardMaterial
    ['Material.003']: THREE.MeshStandardMaterial
    ['Material.007']: THREE.MeshStandardMaterial
    ['Material.005']: THREE.MeshStandardMaterial
    ['Material.009']: THREE.MeshStandardMaterial
    bridgewhite: THREE.MeshStandardMaterial
    ['Material.004']: THREE.MeshStandardMaterial
    streetblack: THREE.MeshStandardMaterial
    ['water.003']: THREE.MeshStandardMaterial
    ['ground water.003']: THREE.MeshStandardMaterial
    dirt: THREE.MeshStandardMaterial
    ['Trunk_1.001']: THREE.MeshStandardMaterial
    ['Treetop_1.001']: THREE.MeshStandardMaterial
    ['Trunk_1.002']: THREE.MeshStandardMaterial
    ['Treetop_1.002']: THREE.MeshStandardMaterial
    ['Trunk_1.003']: THREE.MeshStandardMaterial
    ['Treetop_1.003']: THREE.MeshStandardMaterial
    Treetop_2: THREE.MeshStandardMaterial
    Trunk_2: THREE.MeshStandardMaterial
    ['Treetop_2.001']: THREE.MeshStandardMaterial
    ['Trunk_2.001']: THREE.MeshStandardMaterial
    ['Treetop_2.002']: THREE.MeshStandardMaterial
    ['Trunk_2.002']: THREE.MeshStandardMaterial
    ['Treetop_2.003']: THREE.MeshStandardMaterial
    ['Trunk_2.003']: THREE.MeshStandardMaterial
    ['Treetop_2.004']: THREE.MeshStandardMaterial
    ['Trunk_2.004']: THREE.MeshStandardMaterial
    ['Treetop_2.005']: THREE.MeshStandardMaterial
    ['Trunk_2.005']: THREE.MeshStandardMaterial
    ['Trunk_1.004']: THREE.MeshStandardMaterial
    ['Treetop_1.004']: THREE.MeshStandardMaterial
    ['Treetop_2.006']: THREE.MeshStandardMaterial
    ['Trunk_2.006']: THREE.MeshStandardMaterial
    ['Trunk_1.005']: THREE.MeshStandardMaterial
    ['Treetop_1.005']: THREE.MeshStandardMaterial
    ['Material.001']: THREE.MeshStandardMaterial
    ['Trunk_1.006']: THREE.MeshStandardMaterial
    ['Treetop_1.006']: THREE.MeshStandardMaterial
    ['Treetop_2.007']: THREE.MeshStandardMaterial
    ['Trunk_2.007']: THREE.MeshStandardMaterial
    ['Trunk_1.007']: THREE.MeshStandardMaterial
    ['Treetop_1.007']: THREE.MeshStandardMaterial
    ['Treetop_2.008']: THREE.MeshStandardMaterial
    ['Trunk_2.008']: THREE.MeshStandardMaterial
    ['Treetop_2.009']: THREE.MeshStandardMaterial
    ['Trunk_2.009']: THREE.MeshStandardMaterial
    ['Trunk_1.008']: THREE.MeshStandardMaterial
    ['Treetop_1.008']: THREE.MeshStandardMaterial
    ['Trunk_1.009']: THREE.MeshStandardMaterial
    ['Treetop_1.009']: THREE.MeshStandardMaterial
    ['Trunk_1.010']: THREE.MeshStandardMaterial
    ['Treetop_1.010']: THREE.MeshStandardMaterial
    ['Treetop_2.010']: THREE.MeshStandardMaterial
    ['Trunk_2.010']: THREE.MeshStandardMaterial
    ['Treetop_2.011']: THREE.MeshStandardMaterial
    ['Trunk_2.011']: THREE.MeshStandardMaterial
    ['Treetop_2.012']: THREE.MeshStandardMaterial
    ['Trunk_2.012']: THREE.MeshStandardMaterial
    paddle_2: THREE.MeshStandardMaterial
    None: THREE.MeshStandardMaterial
    Paddle: THREE.MeshStandardMaterial
    tyre_inside: THREE.MeshStandardMaterial
    ['Material.006']: THREE.MeshStandardMaterial
    ['Material.008']: THREE.MeshStandardMaterial
    tye_outside: THREE.MeshStandardMaterial
    Frame: THREE.MeshStandardMaterial
  }
}

export default function CityGood(props: JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>()
  const { nodes, materials } = useGLTF('assets/models/cityGood.glb') as GLTFResult
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-107.05, 0.22, -213.08]} scale={[0.52, 0.92, 0.52]}>
        <mesh geometry={nodes.map_8osm_buildings.geometry} material={materials.b0e0e6} />
        <mesh geometry={nodes.map_8osm_buildings_1.geometry} material={materials['000000']} />
        <mesh geometry={nodes.map_8osm_buildings_2.geometry} material={materials.ffffff} />
        <mesh geometry={nodes.map_8osm_buildings_3.geometry} material={materials.c0c0c0} />
        <mesh geometry={nodes.map_8osm_buildings_4.geometry} material={materials.f0f8ff} />
        <mesh geometry={nodes.map_8osm_buildings_5.geometry} material={materials.dcdcdc} />
      </group>
      <group position={[-96.76, 7.03, 93.48]} rotation={[0, -0.46, 0]} scale={[0.52, 0.92, 0.52]}>
        <mesh geometry={nodes.element011.geometry} material={materials.roof} />
        <mesh geometry={nodes.element011_1.geometry} material={materials.wall} />
        <mesh
          geometry={nodes.Mast_1.geometry}
          material={nodes.Mast_1.material}
          position={[61.98, 30.45, -200.86]}
          rotation={[0, -0.15, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube006_1.geometry}
            material={nodes.Cube006_1.material}
            position={[-156.09, 8.5, 158.31]}
            rotation={[Math.PI, -1, Math.PI]}
            scale={[-23.19, -0.01, -10.98]}
          />
        </mesh>
        <mesh
          geometry={nodes.Mast_1001.geometry}
          material={nodes.Mast_1001.material}
          position={[23.79, 24.43, 30.87]}
          rotation={[0, -0.15, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube001.geometry}
            material={nodes.Cube001.material}
            position={[0, 8.5, 0]}
            rotation={[-Math.PI, 0, -Math.PI]}
            scale={[-19.13, -0.01, -12.97]}
          />
        </mesh>
        <mesh
          geometry={nodes.Mast_1002.geometry}
          material={nodes.Mast_1002.material}
          position={[-50.11, 30.45, -137.17]}
          rotation={[0, 0.86, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube002.geometry}
            material={nodes.Cube002.material}
            position={[65.7, 8.5, 455.92]}
            rotation={[-Math.PI, 0, -Math.PI]}
            scale={[-19.13, -0.01, -12.97]}
          />
        </mesh>
        <mesh
          geometry={nodes.Mast_1003.geometry}
          material={nodes.Mast_1003.material}
          position={[151.69, 30.45, -19.14]}
          rotation={[0, 0.86, 0]}
          scale={[0.65, 4.8, 0.5]}
        />
      </group>
      <group position={[42.43, 9.9, -128.01]} scale={[0.52, 0.92, 0.52]}>
        <mesh geometry={nodes.Blaaktoren_1.geometry} material={nodes.Blaaktoren_1.material} />
        <mesh geometry={nodes.Blaaktoren_2.geometry} material={materials.grey} />
        <group position={[19.64, 0.11, -15]}>
          <mesh geometry={nodes.element002_1.geometry} material={nodes.element002_1.material} />
          <mesh geometry={nodes.element002_2.geometry} material={materials['roof.001']} />
        </group>
      </group>
      <group position={[98.45, 23.77, -126.68]} scale={[0.3, 0.92, 0.3]}>
        <mesh geometry={nodes.Centrale_Bibliotheek_1.geometry} material={materials['wall.005']} />
        <mesh geometry={nodes.Centrale_Bibliotheek_2.geometry} material={materials['roof.005']} />
        <group position={[26.74, -16.54, -10.33]}>
          <mesh geometry={nodes.Centrale_Bibliotheek001_1.geometry} material={materials['wall.007']} />
          <mesh geometry={nodes.Centrale_Bibliotheek001_2.geometry} material={materials['roof.007']} />
        </group>
        <group position={[-8.78, 16.91, -8.36]} scale={[0.45, 0.44, 0.45]}>
          <mesh geometry={nodes.Centrale_Bibliotheek002_1.geometry} material={materials['wall.002']} />
          <mesh geometry={nodes.Centrale_Bibliotheek002_2.geometry} material={materials['roof.002']} />
        </group>
        <mesh
          geometry={nodes.Cylinder.geometry}
          material={nodes.Cylinder.material}
          position={[-61.97, 20.7, 20.08]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.92, 5.23, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder001.geometry}
          material={nodes.Cylinder001.material}
          position={[-69.13, 19.28, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder002.geometry}
          material={nodes.Cylinder002.material}
          position={[-54.03, 19.28, 17.27]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder003.geometry}
          material={nodes.Cylinder003.material}
          position={[-69.13, 13.31, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder004.geometry}
          material={nodes.Cylinder004.material}
          position={[-69.13, 7.26, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder005.geometry}
          material={nodes.Cylinder005.material}
          position={[-69.13, 1.64, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder006.geometry}
          material={nodes.Cylinder006.material}
          position={[-64.37, 1.64, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder007.geometry}
          material={nodes.Cylinder007.material}
          position={[-64.37, 7.26, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder008.geometry}
          material={nodes.Cylinder008.material}
          position={[-64.37, 13.31, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder009.geometry}
          material={nodes.Cylinder009.material}
          position={[-49.28, 19.28, 28.41]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder010.geometry}
          material={nodes.Cylinder010.material}
          position={[-64.37, 19.28, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder011.geometry}
          material={nodes.Cylinder011.material}
          position={[-57.21, 20.7, 31.23]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.92, 5.23, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder012.geometry}
          material={nodes.Cylinder012.material}
          position={[-26.5, 20.7, 38.78]}
          rotation={[-3.11, 1.26, -1.57]}
          scale={[1.92, 5.23, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder013.geometry}
          material={nodes.Cylinder013.material}
          position={[-23.07, 19.28, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder014.geometry}
          material={nodes.Cylinder014.material}
          position={[-28.91, 19.28, 30.71]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder015.geometry}
          material={nodes.Cylinder015.material}
          position={[-23.07, 13.31, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder016.geometry}
          material={nodes.Cylinder016.material}
          position={[-23.07, 7.26, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder017.geometry}
          material={nodes.Cylinder017.material}
          position={[-23.07, 1.64, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
      </group>
      <mesh
        geometry={nodes.Grass001.geometry}
        material={materials['Material.002']}
        position={[-58.16, 10.87, 64.89]}
        rotation={[0, 0.06, 0]}
        scale={[-34.03, -17.77, 37.16]}
      />
      <group position={[17.89, 7.45, -165.27]} scale={[0.52, 0.92, 0.52]}>
        <mesh geometry={nodes.Rotterdam_Blaak_1.geometry} material={materials['wall.006']} />
        <mesh geometry={nodes.Rotterdam_Blaak_2.geometry} material={materials['roof.006']} />
        <mesh
          geometry={nodes.Cylinder018.geometry}
          material={nodes.Cylinder018.material}
          position={[-16.84, 17.63, 10.03]}
          rotation={[0, 0.38, 1.6]}
          scale={[1.92, 7.22, 2.36]}
        />
        <mesh
          geometry={nodes.Cylinder019.geometry}
          material={nodes.Cylinder019.material}
          position={[-29.47, 16.21, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder020.geometry}
          material={nodes.Cylinder020.material}
          position={[-1.71, 15.66, 2.36]}
          scale={[1.92, 1.69, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder021.geometry}
          material={nodes.Cylinder021.material}
          position={[-29.47, 10.24, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder022.geometry}
          material={nodes.Cylinder022.material}
          position={[-29.47, 4.19, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder023.geometry}
          material={nodes.Cylinder023.material}
          position={[-29.47, -1.43, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder024.geometry}
          material={nodes.Cylinder024.material}
          position={[-25.3, 17.63, 12.22]}
          rotation={[0, 0.38, 1.6]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder025.geometry}
          material={nodes.Cylinder025.material}
          position={[-5.37, 18.04, 3.7]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.72, 5.08, 1.9]}
        />
      </group>
      <mesh
        geometry={nodes.Plane.geometry}
        material={nodes.Plane.material}
        position={[93.37, 8.12, -148.64]}
        scale={[102.95, 0.92, 43.5]}
      />
      <mesh
        geometry={nodes.Plane001.geometry}
        material={nodes.Plane001.material}
        position={[39.56, 7.14, 59.39]}
        rotation={[-Math.PI, 1.56, -Math.PI]}
        scale={[86.73, 0.17, 155.54]}
      />
      <mesh
        geometry={nodes.Grass002.geometry}
        material={materials['Material.003']}
        position={[39.69, 7.53, -149.38]}
        scale={[-156.73, -21.46, -82.91]}
      />
      <mesh
        geometry={nodes.Markthal.geometry}
        material={materials['Material.007']}
        position={[162.76, 24.84, -156.89]}
        scale={[23.3, 18.33, 37.28]}>
        <mesh
          geometry={nodes.Cube008.geometry}
          material={materials['Material.005']}
          position={[0, 0, -0.03]}
          scale={[0.98, 0.97, 0.98]}
        />
        <mesh
          geometry={nodes.Cube010.geometry}
          material={materials['Material.009']}
          position={[0, 0, 0.02]}
          scale={[0.98, 0.97, 0.98]}
        />
      </mesh>
      <mesh
        geometry={nodes.Erasmusbrug.geometry}
        material={nodes.Erasmusbrug.material}
        position={[5.97, 8.73, -19.35]}
        rotation={[Math.PI, -1.54, Math.PI]}
        scale={[5.97, 5.68, 3.62]}>
        <mesh geometry={nodes.Cube007_2.geometry} material={nodes.Cube007_2.material} position={[0, 0, -5.21]} />
        <mesh
          geometry={nodes.Cylinder050.geometry}
          material={materials['Material.004']}
          position={[6.26, 5.83, -8.42]}
          rotation={[0, 0, 0.36]}
          scale={[0.1, 7.14, 0.1]}
        />
        <mesh
          geometry={nodes.Cylinder051.geometry}
          material={nodes.Cylinder051.material}
          position={[6.25, 5.83, -2.89]}
          rotation={[0, 0, 0.36]}
          scale={[0.1, 7.14, 0.1]}
        />
        <mesh geometry={nodes.Plane002_1.geometry} material={materials.streetblack} position={[4.16, 0, -2.89]} />
      </mesh>
      <group position={[35.89, -21.59, -40.79]} scale={[87.52, 22.85, 17.94]}>
        <mesh geometry={nodes.Cube007.geometry} material={materials['water.003']} />
        <mesh geometry={nodes.Cube007_1.geometry} material={materials['ground water.003']} />
      </group>
      <mesh
        geometry={nodes.Cube.geometry}
        material={nodes.Cube.material}
        position={[39.18, 1.76, 58.02]}
        scale={[155.71, 5.15, 85.02]}
      />
      <mesh
        geometry={nodes.Cube004.geometry}
        material={nodes.Cube004.material}
        position={[39.18, 1.76, -150.52]}
        scale={[155.71, 5.15, 82.15]}
      />
      <group position={[101.81, 6.51, 135.77]} rotation={[Math.PI / 2, 0, 1.97]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1001_1.geometry} material={materials['Trunk_1.001']} />
        <mesh geometry={nodes.Tree_1001_2.geometry} material={materials['Treetop_1.001']} />
      </group>
      <group position={[201.78, 6.51, -208.15]} rotation={[Math.PI / 2, 0, -0.01]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1002_1.geometry} material={materials['Trunk_1.002']} />
        <mesh geometry={nodes.Tree_1002_2.geometry} material={materials['Treetop_1.002']} />
      </group>
      <group position={[-80.33, 6.51, -156.44]} rotation={[Math.PI / 2, 0, 2.9]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1003_1.geometry} material={materials['Trunk_1.003']} />
        <mesh geometry={nodes.Tree_1003_2.geometry} material={materials['Treetop_1.003']} />
      </group>
      <group position={[-44.2, 7.43, -173.46]} rotation={[Math.PI / 2, 0, -1.33]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2_1.geometry} material={materials.Treetop_2} />
        <mesh geometry={nodes.Tree_2_2.geometry} material={materials.Trunk_2} />
      </group>
      <group position={[-122.41, 7.43, -91.45]} rotation={[Math.PI / 2, 0, -0.21]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2001_1.geometry} material={materials['Treetop_2.001']} />
        <mesh geometry={nodes.Tree_2001_2.geometry} material={materials['Trunk_2.001']} />
      </group>
      <group position={[-55.03, 6.8, -125.25]} rotation={[Math.PI / 2, 0, -0.4]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2002_1.geometry} material={materials['Treetop_2.002']} />
        <mesh geometry={nodes.Tree_2002_2.geometry} material={materials['Trunk_2.002']} />
      </group>
      <group position={[-111.92, 7.43, -187.12]} rotation={[Math.PI / 2, 0, 0.14]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2003_1.geometry} material={materials['Treetop_2.003']} />
        <mesh geometry={nodes.Tree_2003_2.geometry} material={materials['Trunk_2.003']} />
      </group>
      <group position={[-86.14, 7.43, -149.56]} rotation={[Math.PI / 2, 0, 2.18]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2004_1.geometry} material={materials['Treetop_2.004']} />
        <mesh geometry={nodes.Tree_2004_2.geometry} material={materials['Trunk_2.004']} />
      </group>
      <group position={[64.39, 7.43, -217.03]} rotation={[Math.PI / 2, 0, -2.6]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2005_1.geometry} material={materials['Treetop_2.005']} />
        <mesh geometry={nodes.Tree_2005_2.geometry} material={materials['Trunk_2.005']} />
      </group>
      <group position={[-24.16, 6.51, -208.15]} rotation={[Math.PI / 2, 0, 1.93]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1004_1.geometry} material={materials['Trunk_1.004']} />
        <mesh geometry={nodes.Tree_1004_2.geometry} material={materials['Treetop_1.004']} />
      </group>
      <group position={[144.21, 6.8, -70.02]} rotation={[Math.PI / 2, 0, -1.25]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2006_1.geometry} material={materials['Treetop_2.006']} />
        <mesh geometry={nodes.Tree_2006_2.geometry} material={materials['Trunk_2.006']} />
      </group>
      <group position={[-56.19, 6.51, -128.17]} rotation={[Math.PI / 2, 0, -1.01]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1005_1.geometry} material={materials['Trunk_1.005']} />
        <mesh geometry={nodes.Tree_1005_2.geometry} material={materials['Treetop_1.005']} />
      </group>
      <mesh
        geometry={nodes.Grass003.geometry}
        material={materials['Material.001']}
        position={[90.22, 7.53, 59.32]}
        scale={[-104.67, -21.46, -84.55]}
      />
      <group position={[11.09, 6.51, -10.77]} rotation={[Math.PI / 2, 0, 0]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1006_1.geometry} material={materials['Trunk_1.006']} />
        <mesh geometry={nodes.Tree_1006_2.geometry} material={materials['Treetop_1.006']} />
      </group>
      <group position={[-13.73, 7.62, 77.58]} rotation={[Math.PI / 2, 0, 0]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2007_1.geometry} material={materials['Treetop_2.007']} />
        <mesh geometry={nodes.Tree_2007_2.geometry} material={materials['Trunk_2.007']} />
      </group>
      <group position={[-39.01, 6.51, -86.01]} rotation={[Math.PI / 2, 0, -2.29]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1007_1.geometry} material={materials['Trunk_1.007']} />
        <mesh geometry={nodes.Tree_1007_2.geometry} material={materials['Treetop_1.007']} />
      </group>
      <group position={[28.98, 7.62, 135.52]} rotation={[Math.PI / 2, 0, -1.2]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2008_1.geometry} material={materials['Treetop_2.008']} />
        <mesh geometry={nodes.Tree_2008_2.geometry} material={materials['Trunk_2.008']} />
      </group>
      <group position={[84.28, 7.62, 79.07]} rotation={[Math.PI / 2, 0, 0.76]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2009_1.geometry} material={materials['Treetop_2.009']} />
        <mesh geometry={nodes.Tree_2009_2.geometry} material={materials['Trunk_2.009']} />
      </group>
      <group position={[188.71, 7.59, 86.98]} rotation={[Math.PI / 2, 0, 0.84]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1008_1.geometry} material={materials['Trunk_1.008']} />
        <mesh geometry={nodes.Tree_1008_2.geometry} material={materials['Treetop_1.008']} />
      </group>
      <group position={[79.82, 6.51, 40.78]} rotation={[Math.PI / 2, 0, 0]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1009_1.geometry} material={materials['Trunk_1.009']} />
        <mesh geometry={nodes.Tree_1009_2.geometry} material={materials['Treetop_1.009']} />
      </group>
      <group position={[87.17, 6.51, -5.26]} rotation={[Math.PI / 2, 0, -1.18]} scale={[0.94, 0.92, 0.78]}>
        <mesh geometry={nodes.Tree_1010_1.geometry} material={materials['Trunk_1.010']} />
        <mesh geometry={nodes.Tree_1010_2.geometry} material={materials['Treetop_1.010']} />
      </group>
      <group position={[129.46, 7.62, 19.78]} rotation={[Math.PI / 2, 0, -2.45]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2010_1.geometry} material={materials['Treetop_2.010']} />
        <mesh geometry={nodes.Tree_2010_2.geometry} material={materials['Trunk_2.010']} />
      </group>
      <group position={[27.9, 7.62, -8.96]} rotation={[Math.PI / 2, 0, 0]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2011_1.geometry} material={materials['Treetop_2.011']} />
        <mesh geometry={nodes.Tree_2011_2.geometry} material={materials['Trunk_2.011']} />
      </group>
      <group position={[135.12, 7.62, 115.49]} rotation={[Math.PI / 2, 0, -0.35]} scale={[0.86, 0.7, 0.82]}>
        <mesh geometry={nodes.Tree_2012_1.geometry} material={materials['Treetop_2.012']} />
        <mesh geometry={nodes.Tree_2012_2.geometry} material={materials['Trunk_2.012']} />
      </group>
      <mesh
        geometry={nodes.Cube003.geometry}
        material={nodes.Cube003.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Plane006.geometry}
        material={nodes.Plane006.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cube005.geometry}
        material={nodes.Cube005.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.NurbsCurve003.geometry}
        material={nodes.NurbsCurve003.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.NurbsCurve002.geometry}
        material={nodes.NurbsCurve002.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.NurbsCurve001.geometry}
        material={nodes.NurbsCurve001.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.NurbsCurve.geometry}
        material={nodes.NurbsCurve.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle007.geometry}
        material={nodes.Circle007.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle006.geometry}
        material={nodes.Circle006.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle005.geometry}
        material={nodes.Circle005.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle004.geometry}
        material={nodes.Circle004.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cube004_Cube003.geometry}
        material={materials['Material.006']}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cube003_Cube002.geometry}
        material={materials['Material.008']}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder041_Cylinder042.geometry}
        material={nodes.Cylinder041_Cylinder042.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle003.geometry}
        material={nodes.Circle003.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder038_Cylinder039.geometry}
        material={nodes.Cylinder038_Cylinder039.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder037_Cylinder038.geometry}
        material={nodes.Cylinder037_Cylinder038.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder036_Cylinder037.geometry}
        material={nodes.Cylinder036_Cylinder037.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder035_Cylinder036.geometry}
        material={nodes.Cylinder035_Cylinder036.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder033_Cylinder034.geometry}
        material={nodes.Cylinder033_Cylinder034.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder032_Cylinder033.geometry}
        material={nodes.Cylinder032_Cylinder033.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder029_Cylinder030.geometry}
        material={nodes.Cylinder029_Cylinder030.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder028_Cylinder029.geometry}
        material={nodes.Cylinder028_Cylinder029.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder027_Cylinder028.geometry}
        material={nodes.Cylinder027_Cylinder028.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder025_Cylinder026.geometry}
        material={nodes.Cylinder025_Cylinder026.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder022_Cylinder023.geometry}
        material={nodes.Cylinder022_Cylinder023.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder021_Cylinder022.geometry}
        material={nodes.Cylinder021_Cylinder022.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle002.geometry}
        material={nodes.Circle002.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle001.geometry}
        material={nodes.Circle001.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder020_Cylinder021.geometry}
        material={nodes.Cylinder020_Cylinder021.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder017_Cylinder018.geometry}
        material={nodes.Cylinder017_Cylinder018.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder016_Cylinder017.geometry}
        material={nodes.Cylinder016_Cylinder017.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder014_Cylinder015.geometry}
        material={nodes.Cylinder014_Cylinder015.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder013_Cylinder014.geometry}
        material={nodes.Cylinder013_Cylinder014.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder012_Cylinder013.geometry}
        material={nodes.Cylinder012_Cylinder013.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder011_Cylinder012.geometry}
        material={nodes.Cylinder011_Cylinder012.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder009_Cylinder010.geometry}
        material={nodes.Cylinder009_Cylinder010.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder006_Cylinder007.geometry}
        material={nodes.Cylinder006_Cylinder007.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder004_Cylinder005.geometry}
        material={nodes.Cylinder004_Cylinder005.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder002_Cylinder003.geometry}
        material={nodes.Cylinder002_Cylinder003.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Circle.geometry}
        material={nodes.Circle.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder056.geometry}
        material={nodes.Cylinder056.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder057.geometry}
        material={nodes.Cylinder057.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cube001_Cube000.geometry}
        material={nodes.Cube001_Cube000.material}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
      <mesh
        geometry={nodes.Cube_Cube001.geometry}
        material={materials.Frame}
        position={[18.69, 9.09, -76.91]}
        rotation={[Math.PI / 2, 0, 1.62]}
        scale={[2.48, 0.93, 2.44]}
      />
    </group>
  )
}

useGLTF.preload('assets/models/cityGood.glb')
